import { Check } from "lucide-react";

const approaches = [
  "Drama-based, experiential sessions",
  "Rehearsal-room techniques applied to real work scenarios",
  "Safe, structured environments for practice",
  "Focus on embodiment, voice and presence",
  "Play used as a tool for growth (not frivolity)",
];

export default function HowIWorkSection({ isVisible }) {
  return (
    <section
      id="how-i-work"
      className={`py-24 lg:py-32 bg-[#F9F6F0] transition-all duration-700 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
      data-testid="how-i-work-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Text Content */}
          <div>
            <h2 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl lg:text-5xl font-medium text-[#1A1A1A] mb-8 heading-decorated">
              How I Work
            </h2>
            
            <ul className="space-y-5 mb-10">
              {approaches.map((approach, index) => (
                <li
                  key={index}
                  className="flex items-start font-['Manrope'] text-[#4A4542]"
                  data-testid={`approach-item-${index}`}
                >
                  <Check
                    size={20}
                    strokeWidth={2}
                    className="text-[#8B5A2B] mr-4 mt-0.5 flex-shrink-0"
                  />
                  <span>{approach}</span>
                </li>
              ))}
            </ul>

            {/* Quote */}
            <div className="border-l-2 border-[#C5A059] pl-6 py-2">
              <p className="font-['Cormorant_Garamond'] text-xl lg:text-2xl text-[#1A1A1A] italic">
                "Rehearsal allows people to practise, explore and grow before the
                real moment."
              </p>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="responsive-image">
              <img
                src="https://images.unsplash.com/photo-1587288672797-74093d795afc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxjYWxtJTIwbmF0dXJhbCUyMHdvb2QlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzUzOTAyMTh8MA&ixlib=rb-4.1.0&q=85"
                alt="Calm workshop space"
                className="w-full h-auto object-cover"
                data-testid="how-i-work-image"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-[#C5A059]/20 -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
